import * as React from 'react';

import * as Yup from 'yup';
import { withFormik, FormikProps, Form, Field } from 'formik';
import { compose } from 'redux';
import { RouteComponentProps } from 'react-router-dom';
import { AxiosResponse, AxiosError } from 'axios';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import * as actions from '../../modules/user/action';
import { IRole, IUser } from '../../@types';
import axios from '../../common/axios-instance/axios-instance';
import withEditContainer, {
  IEditContainedProps
} from '../../common/edit-container/edit-container';
import FormikSelect from '../../common/formik/formik-select';
import EditIcons from '../../common/edit-icons/edit-icons';
import DeleteDialog from '../../common/delete-dialog/delete-dialog';
import FormikTextField from '../../common/formik/formik-text-field';

// Formik values for the form
export interface IUserFormValues {
  email: string;
  password?: string;
  roleId: string;
}

let requirePW = true;

const formikEnhancer = withFormik<
  IEditContainedProps & RouteComponentProps<any>,
  IUserFormValues
>({
  mapPropsToValues: props => {
    const user = props.entity as IUser;
    return {
      email: user.email || '',
      password: '',
      roleId: user.roleId ? user.roleId.toString() : ''
    };
  },
  validationSchema: Yup.object().shape({
    email: Yup.string()
      .email('This must be an email address')
      .required('Email is required'),
    password: Yup.string()
      .min(5)
      .nullable(true),
    // password: Yup.string().when('requirePW', {
    //     is: true,
    //     then: Yup.string().required("Passphrase is required"),
    //     otherwise: Yup.string().notRequired(),
    // }),
    roleId: Yup.number()
  }),
  handleSubmit: (values, formikActions) => {
    const props = formikActions.props;
    const valuesToUser: IUser = {
      email: values.email,
      id: props.entity.id,
      password: requirePW ? values.password : '',
      roleId: Number(values.roleId), // cast back to number on submit
      createdDate: new Date(),
      updatedDate: new Date()
    };

    props.onEntitySubmit(valuesToUser, formikActions);
  }
});

interface IRoleOption {
  label: string;
  value: string;
}

interface IUserEntryState {
  roles: IRoleOption[];
}

class UserEntry extends React.Component<
  FormikProps<IUserFormValues> & IEditContainedProps
> {
  user: IUser = this.props.entity as IUser;

  state: IUserEntryState = {
    roles: [
      {
        label: 'Default',
        value: '1'
      }
    ]
  };

  cancelTasks = false;

  componentWillMount = () => {
    this.updateRolesList();
  };

  componentWillUnmount = () => {
    this.cancelTasks = true;
  };

  componentDidMount = () => {
    if (this.user.id) {
      requirePW = false;
    } else {
      requirePW = true;
    }
  };

  updateRolesList = (): void | Promise<any> => {
    let url;
    url = '/api/role';

    return axios
      .get<IRole[]>(url)
      .then((response: AxiosResponse<IRole[]>) => {
        const content = response.data;

        const temp: IRoleOption[] = content.map(
          r =>
            ({
              value: r.id != null ? r.id.toString() : '',
              label: r.name
            } as IRoleOption)
        );

        if (!this.cancelTasks) {
          this.setState({ roles: temp });
        }
      })
      .catch((error: AxiosError) => {
        console.log(error.message);
      });
  };

  render(): JSX.Element {
    const {
      isSubmitting,
      onEditCancel,
      onEditStart,
      formDisabled,
      deleteFn
    } = this.props; // touched, errors

    return (
      <Form>
        <Card>
          <CardHeader
            title={this.user.id ? 'Edit ' + this.user.email : 'Add User'}
            action={
              <EditIcons
                formDisabled={formDisabled}
                isSubmitting={isSubmitting}
                showEdit={!!this.user.id}
                onEditStart={onEditStart}
                onEditCancel={onEditCancel}
                showDelete={false} // Hide delete for now, later !!this.user.id
              />
            }
          />
          <CardContent>
            <div>
              <Field
                id="user-email-input"
                name="email"
                label="Email"
                fullWidth
                disabled={formDisabled}
                component={FormikTextField}
              />
            </div>
            <div>
              <Field
                id="user-password-input"
                name="password"
                label="Password"
                fullWidth
                disabled={formDisabled || !requirePW} // Only allow password entry on create
                component={FormikTextField}
              />
            </div>

            <h4> Role </h4>

            <Field
              id="user-role-name-input"
              name="roleId"
              label="Role Options"
              fullWidth
              disabled={formDisabled}
              component={FormikSelect}
              options={this.state.roles}
            />
          </CardContent>
        </Card>
        <DeleteDialog
          entity={this.user}
          title={'Delete user?'}
          prompt={
            <div>
              <p>
                Deleting user with email {this.user.email}! This cannot be
                undone. A new user will have to be created in its place.
              </p>
            </div>
          }
          deleteEntity={deleteFn}
        />
      </Form>
    );
  }
}

const config = {
  get: actions.getUser,
  update: actions.updateUser,
  clear: actions.clearUser,
  deleteFn: actions.deleteUser,
  submit: actions.submitUser,
  goBackOnEditEnd: false,
  reducerName: 'userReducer',
  entityName: 'user',
  formikEnhancer
};

const enhance = compose(withEditContainer(config));

export default enhance(UserEntry);



// WEBPACK FOOTER //
// ./src/features/user-entry/user-entry.tsx